import { useEffect } from "react";
import { type RefObject } from "react";

import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Description } from "@/components/Description";
import { FormButton } from "@/components/form/FormButton";
import { FormFieldError } from "@/components/form/FormField";
import { FormInput } from "@/components/form/FormInput";
import { useForm } from "@/components/form/hooks/useForm";
import { useFormField } from "@/components/form/hooks/useFormField";
import { Title } from "@/components/Title";
import { useStore } from "@/store";
import { twMerge } from "@/utils/twMerge";

import type { TeamFormFields } from "@/models/api/TeamApi";

export const StepTitle = observer(function StepTitle() {
  const { dialog } = useStore();
  const { createTeamDialog } = dialog;
  const t = useTranslations();

  const { formProps, register } = useForm<TeamFormFields>(async (_fields, e) => {
    e.preventDefault();
    createTeamDialog.setStep("permalink");
    return Promise.resolve();
  });
  const titleFormFields = useFormField("title", createTeamDialog, register);

  useEffect(() => {
    const ref = titleFormFields.inputProps.ref as RefObject<HTMLInputElement | null>;
    if (ref?.current) {
      ref.current.focus();
    }
  }, [titleFormFields.inputProps.ref]);

  return (
    <form className={twMerge("flex flex-col")} noValidate {...formProps} autoComplete="off">
      <Title value={t("createTeamDialog.stepTitle.title")} />
      <Description value={t("createTeamDialog.stepTitle.description")} />
      <div className="flex flex-col mb-5">
        <FormInput
          placeholder={t("createTeamDialog.stepTitle.placeholder")}
          aria-label={t("createTeamDialog.stepTitle.placeholder")}
          type="text"
          {...titleFormFields.inputProps}
        />
        <FormFieldError message={titleFormFields.errorMessage} />
      </div>
      <FormButton variant="accent" size="sm" type="submit" className="w-full">
        {t("createTeamDialog.continueButton")}
      </FormButton>
    </form>
  );
});
